import { combineReducers } from "@reduxjs/toolkit";
import yourReducer from "./your-reducer";
import sseReducer from "./sse-slice";
import featureFlagsReducer from "./feature-flags-slice";
import onboardingReducer from "./onboarding-slice";
import gatewaysMachinesReducer from "./gateways-machines-slice";
import dashboardsReducer from "./dashboards-slice";
import unitsReducer from "./units-slice";

const rootReducer = combineReducers({
  yourSlice: yourReducer,
  sseSlice: sseReducer,
  featureFlags: featureFlagsReducer,
  onboardingSlice: onboardingReducer,
  gatewaysMachinesSlice: gatewaysMachinesReducer,
  dashboards: dashboardsReducer,
  units: unitsReducer,
});

export default rootReducer;
